// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"PricesRealized-module--videoWrapper--11uPu","videoSection":"PricesRealized-module--videoSection--2XXJX"};